import { getAgpApiUrl, smb_fetch } from '@/api/operator/fetch';

export const getComponentPreviewList = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/component_pre_audit', 'list_components');
  return smb_fetch(url, {
    method: 'POST',
    isCancel: true,
    ...data,
  }, true, false);
};

export const getComponentUnitList = (data: any = {}) => {
  const url = getAgpApiUrl('eservice/component_pre_audit_config', 'list_config_unit');
  return smb_fetch(url, {
    method: 'POST',
    data,
  }, false, false);
};
